<template>
  <v-form v-model="formIsValid">
    <v-checkbox
        v-model="active"
        label="Изменить ссылки на элементы"
        @change="overrideToggle"
    ></v-checkbox>
    <v-row
        v-if="active"
        dense
    >
      <v-col
          v-for="url in innerUrls"
          :key="url.id"
          cols="12"
          sm="6"
          md="4"
      >
        <v-text-field
            v-model="url.url"
            type="url"
            :label="url.title"
            :rules="urlRules"
            @change="urlIsChanged"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'SourceSettingsWidgetUrls',
  created () {
    if (this.settings && this.settings.override.urls) {
      this.active = true
    }
    this._copyUrls(this.urls)
  },
  data () {
    return {
      active: false,
      formIsValid: false,
      innerUrls: [],
      urlRules: [
        v => !!v && (v.startsWith('http://vk.com') || v.startsWith('https://vk.com'))
            || 'Необходима ссылка вида https://vk.com'
      ]
    }
  },
  methods: {
    urlIsChanged () {
      this.$emit('update', this.innerUrls)
      this.$emit('validate', this.formIsValid)
    },
    overrideToggle (active) {
      if (active){
        this.urlIsChanged()
      } else {
        this.$emit('clear')
        this.$emit('validate', true)
      }
    },
    _copyUrls (val) {
      const res = []
      if (val && val.length) {
        val.forEach(elm => {
          const edited = this.innerUrls.find(s => s.id === elm.id)
          if (edited && edited.id === elm.id) {
            res.push(edited)
          } else {
            res.push(elm)
          }
        })
      }
      this.innerUrls = JSON.parse(JSON.stringify(res))
    }
  },
  props: {
    settings: {
      required: true,
      type: Object
    },
    urls: {
      required: true,
      type: Array
    }
  },
  watch: {
    urls (val) {
      this._copyUrls(val)
      this.urlIsChanged()
    }
  }
}
</script>

<style scoped>

</style>